module.exports = __webpack_public_path__ + "static/media/bg-area.c25195da.jpeg";